import { TableCell, Tooltip } from "@mui/material";

import { useTranslation } from "react-multi-lang";
import { iSelectCellProps } from "./common";




export function SelectWindow (props:iSelectCellProps){
    const t = useTranslation()


    return (
                          <Tooltip

                            title={props.not_valid?
                                props.msg_err:''
                            }
                            slotProps={{
                              tooltip: {
                                sx: {

                                  background: 'white',
                                  color: 'red',
                                  border: '1px solid red'
                                }
                              }
                            }}
                            key={props.index}
                          >

                            <div
                              
                              style={{
                                borderColor: 'lightgray',
                                borderLeft: '1px dashed  lightgray',
                                borderLeftStyle: 'dashed',
                                padding: '0px',
                                verticalAlign: 'center',
                                border:
                                  props.not_valid ?
                                    "1px solid red"

                                    : '',
                                width:'100%',
                                maxWidth:'100%'
                              }}>

                              <select
                                disabled={props.disabled}
                                onKeyDown={props.handleKeyDown}
                                style={{
                                  maxWidth:'100%'
                                }}
                                value={props.value}
                                className={props.className}
                                name={
                                 props.input_name
                                }
                                onClick={() => props.setFieldTouched ? props.setFieldTouched(props.input_name, true) : undefined}

                                onChange={(e: React.ChangeEvent) => 

                                 props.handleChange? props.handleChange(e, props.row_number??-1):undefined
                                }>
                                <>
                                  <option value="">{t('select...')}</option>
                                  {props.options?.map((ele: any, j: number) => {
                                      return (
                                        <option

                                          value={ele.value ? ele.value : ''}
                                          key={'options[elem]' + j}
                                        >
                                          {ele.name ? ele.name : ''}
                                        </option>
                                      );
                                    })
                                  
                                  }
                                </>
                              </select>
                            </div>
                          </Tooltip>
    )
}